// Ce fichier sert uniquement de pont pour ne pas casser les imports existants
import FuelView from './schedule/ScheduleView';
export default FuelView;